<template>
  <WebChapterTemplate
    page-title="新闻与传播研究网"
    section-label="传播与平台"
    section-route="/lanhu_chuanboyupingtai"
    :top-strip-image="topStripImage"
    :hero-background-image="heroBackgroundImage"
  >
    <section class="page-section">
      <article class="content-card">
        <h2 class="section-title">新闻与传播研究网</h2>
        <p class="body-text">
          2002 年 12 月 26 日，新闻与传播研究网的前身传播研究网正式开通。此后网站逐步扩展为研究所的重要线上传播平台，并形成了新闻与传播研究网、新闻学与传播学名词审定学术交流网、新闻与传播数字博物馆引导页等多个专题入口。
        </p>

        <div class="portal-grid">
          <figure class="portal-figure">
            <img :src="images.portal2002" alt="2002 年 12 月 26 日传播研究网正式开通" />
            <figcaption>2002 年 12 月 26 日，新闻与传播研究网的前身传播研究网正式开通</figcaption>
          </figure>
          <figure class="portal-figure">
            <img :src="images.portalMain" alt="新闻与传播研究网" />
            <figcaption>新闻与传播研究网</figcaption>
          </figure>
          <figure class="portal-figure">
            <img :src="images.portalTerms" alt="新闻学与传播学名词审定学术交流网" />
            <figcaption>新闻学与传播学名词审定学术交流网</figcaption>
          </figure>
          <figure class="portal-figure">
            <img :src="images.portalMuseum" alt="新闻与传播数字博物馆引导页" />
            <figcaption>新闻与传播数字博物馆引导页</figcaption>
          </figure>
        </div>
      </article>
    </section>
  </WebChapterTemplate>
</template>

<script>
import WebChapterTemplate from '@/components/WebChapterTemplate.vue';

export default {
  name: 'NewLanhuXinwenyuchuanboyanjiuwang',
  components: {
    WebChapterTemplate
  },
  data() {
    return {
      topStripImage: require('@/views/lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png'),
      heroBackgroundImage: require('@/views/lanhu_zhengwenyexueshuchengguo/assets/img/173301bb9c6d42d7ae3028c182487260_mergeImage.png'),
      images: {
        portal2002: require('./assets/portal-2002.jpg'),
        portalMain: require('./assets/portal-main.jpg'),
        portalTerms: require('./assets/portal-terms.jpg'),
        portalMuseum: require('./assets/portal-museum.jpg')
      }
    };
  }
};
</script>

<style scoped>
.page-section {
  margin-bottom: 48px;
}

.page-section:last-child {
  margin-bottom: 0;
}

.content-card {
  padding: 28px;
  border-radius: 10px;
  background:
    linear-gradient(135deg, rgba(250, 245, 238, 0.74), rgba(255, 255, 255, 0) 48%),
    linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(252, 250, 246, 0.96));
  border: 1px solid rgba(179, 145, 101, 0.18);
}

.section-title {
  margin: 0 0 16px;
  color: #f25c19;
  font-size: 24px;
  line-height: 1.4;
  font-weight: 700;
  font-family: 'Songti SC', 'STSong', 'Noto Serif SC', serif;
}

.body-text {
  margin: 0 0 22px;
  color: #231f20;
  font-size: 15px;
  line-height: 1.9;
  text-align: justify;
  text-indent: 2em;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.portal-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 18px;
}

.portal-figure {
  margin: 0;
}

.portal-figure img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 4px;
  box-shadow: 0 8px 22px rgba(45, 33, 16, 0.08);
}

.portal-figure figcaption {
  margin-top: 10px;
  color: #6f6253;
  font-size: 12px;
  line-height: 1.6;
  text-align: center;
}

@media (max-width: 1100px) {
  .portal-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .portal-grid {
    grid-template-columns: 1fr;
  }

  .content-card {
    padding: 18px;
  }
}
</style>
